module.exports = __webpack_public_path__ + "static/media/bridgewater.c72e605b.png";